import React, { FC } from 'react';
import { Stalled, StalledContent } from 'QuoteApp/components';

export const OutOfMarket: FC = () => {
  return (
    <Stalled testId="out-of-market-page">
      <StalledContent variant="headline">Out of Market</StalledContent>
      <StalledContent>
        We're not in your state yet, but we're coming soon!
      </StalledContent>
      <StalledContent>
        If you believe the stop was made in error, we’re here to help. Use the
        chat function to reach out to our Agent Advocate team.
      </StalledContent>
    </Stalled>
  );
};
